import React, {useEffect} from 'react';

import {useFetchData} from '../../../infrastructure/hooks/useFetchData';
import * as VendorsService from '../../../services/VendorsService';
import {ApiStatus} from '../../../infrastructure/constants/apiStatus';
import {FranchiseVendor} from "../../../types/Vendor";

import AutoComplete, {AutoCompleteProps} from "./AutoComplete";


const getOptionLabel = (vendor: FranchiseVendor | undefined): string => {
  if (!vendor) return '';

  return `${vendor.name}`;
};
const getOptionValue = (vendor: FranchiseVendor): string => {
  return vendor.id;
};

const FranchiseVendorsAutoComplete = (props: AutoCompleteProps<FranchiseVendor>) => {
  const [fetchStatus, franchiseVendors, fetchFranchiseVendors] = useFetchData<
    FranchiseVendor[] | undefined
  >();

  useEffect(() => {
    fetchFranchiseVendors(() =>
      VendorsService.getFranchiseVendors()
    );
  }, [fetchFranchiseVendors]);

  return (
    <AutoComplete
      {...props}
      initialId={props.initialId}
      options={franchiseVendors || []}
      isLoading={fetchStatus === ApiStatus.loading}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
    />
  );
};

export default FranchiseVendorsAutoComplete;
